import { render, staticRenderFns } from "./StatusChangeBar.vue?vue&type=template&id=b7472efa&scoped=true&"
import script from "./StatusChangeBar.vue?vue&type=script&lang=js&"
export * from "./StatusChangeBar.vue?vue&type=script&lang=js&"
import style0 from "./StatusChangeBar.vue?vue&type=style&index=0&id=b7472efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7472efa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7472efa')) {
      api.createRecord('b7472efa', component.options)
    } else {
      api.reload('b7472efa', component.options)
    }
    module.hot.accept("./StatusChangeBar.vue?vue&type=template&id=b7472efa&scoped=true&", function () {
      api.rerender('b7472efa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/manageGoodsGroup/components/StatusChangeBar.vue"
export default component.exports